import { FC } from 'react';

import { Info } from '../Info';
import type { FieldRendererProps } from './Fields.types';
import { formatFieldValue, getIconForField } from './utils';

export const PlainFieldRenderer: FC<FieldRendererProps> = ({
	field,
	formatValue = formatFieldValue,
	getIcon = getIconForField,
	currency,
	locale,
	timeFormat24,
}) => {
	const text = formatValue(field, { currency, locale, timeFormat24 });
	if (!text) return null;

	return <Info icon={getIcon(field)} text={text} />;
};
